import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { TrendsExplorerProvider as Provider } from '../../components/context/trends-explorer-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllTrendsExplorerQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Trends" } }) {
    nodes {
      data
    }
  }
}
`;

export const TrendsExplorerProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
